export const environment = {
  production: true,
  apiUrl: "https://www.trivenispinningmills.net"
};
